import { BgzipIndexedFasta, IndexedFasta } from '@gmod/indexedfasta'
//import { RemoteFile } from 'generic-filehandle'
import { openLocation } from '@jbrowse/core/util/io'
import { TabixIndexedFile } from '@gmod/tabix'
import VCF from '@gmod/vcf'
import _ from 'lodash'
import { relative } from 'path'

async function generateSequences(data, progressIndicator){
    return new Promise((resolve,reject)=>{
        (async() =>{
            try {
                console.log(data)
                //const customVCF = data.customVCF && data.customTBI;
                progressIndicator(0);
                // Get reference sequence
                const referenceSequence = await readReferenceSequence(data.fastaFile, data.faiFile, data.region)
                progressIndicator(10);
                // Get SNPs if we had a VCF file and a TBI file
                let variants = []
                if(data.vcfFile !== "" && data.tbiFile !== "" && data.vcfFile !== undefined && data.tbiFile !== undefined)
                    variants = await readVariantInfo(data.vcfFile, data.tbiFile, data.region)
                console.log(variants)
                /*var variantsCustom = null;
                if(customVCF){
                    variantsCustom = await readVariantInfo(data.customVCF, data.customTBI, data.region)
                }*/
                progressIndicator(20);
                // Get sequences for individuals
                var [sequences, offsets] = buildSequences(referenceSequence, variants, data.individuals, data.region, data.filters)
                /*if(customVCF){
                    const sequencesCustom = buildSequences(referenceSequence, variantsCustom, data.individuals, data.region, data.filters, "user_")
                    sequences = {...sequencesCustom, ...sequences}
                }*/

                progressIndicator(60);
                // Build consensus sequence
                sequences = buildConsensus(sequences);
                progressIndicator(80);
                // Convert to fasta
                const fastas = sequencesToFasta(data.referenceGenome.name, data.codes,sequences)
                progressIndicator(100);
                return resolve([fastas, offsets]);
            } catch (err){
                progressIndicator(0);
                return reject(err);
            }
        } )()
    });
}

function sequencesToFasta(referenceName, codes, sequences){
    // Convert allele array to string
    Object.keys(sequences).forEach((key) => {
        sequences[key] = sequences[key].join('');
    });
    const fastas = {"reference": `>Reference ${referenceName}\n${sequences['reference']}`};
    fastas["consensus"] = `>Consensus\n${sequences['consensus']}`
    //console.log(sequences);
    //console.log(codes);
    for(let i=0; i< Object.keys(sequences).length; i++){
        const indiv = Object.keys(sequences)[i];
        var code = "";
        if (codes.length > 0)
            code = codes[i];
        if (indiv !== 'consensus' && indiv !== 'reference')
        {
            fastas[indiv] = `>${indiv}ㅤ${code}\n${sequences[indiv]}`;
        }
    }
    fastas['all'] = Object.values(fastas).join('\n');
    // console.log(fastas["Mdo_Fur_4"])
    return fastas
}

// IUPAC ambiguity codes
const alleleToIUPAC = {
    'AG': 'R',
    'AC': 'M',
    'AT': 'W',
    'CG': 'S',
    'CT': 'Y',
    'GT': 'K',
    'CGT': 'B',
    'AGT': 'D',
    'ACT': 'H',
    'ACG': 'V',
    'ACGT': 'N'
}
const IUPACToAllele = _.invert(alleleToIUPAC);

function buildSequences(referenceSequence, variants, individuals, region, filters, sequencePrefix = ""){
    const allIndividuals = individuals.length === 0;
    // Initialize consensus sequence for each individual with reference sequence
    var sequences = {};
    if (!allIndividuals)
    {
        sequences = {...Object.fromEntries(individuals.map(indiv => [sequencePrefix+indiv, [...referenceSequence]]))}
    }

    // Add reference sequence
    sequences['reference'] = [...referenceSequence]
    // Offset for the SNPs position so that insertions dont alter the position of the next SNP
    var totalOffset = 0;
    // Store offset at each position
    var offsets = {};
    variants.forEach((variant) => {
        // Check variant corresponds to chromosome
        /* This check is disabled since it is assumed that the VCF file is separated by chromosome
        if (variant.CHROM !== region.chr.toString()) {
            throw(new Error(`Variant chromosome ${variant.CHROM} does not match region chromosome ${region.chr}`))
        }*/
        const alleles = [variant.REF, ...variant.ALT]
        // Compute the position in the current window
        var relativePos = variant.POS - region.start + totalOffset;
        // Check if variant is in region
        if (relativePos < 0 || relativePos > sequences['reference'].length) {
            // If its insertion or deletion, it can be outside the region. We just have to take the part that is inside the region
            if (alleles.some(allele => allele.length > 1)){
                console.warn("Correcting for INDEL outside region")
                // Trim alleles to the region
                alleles.forEach((allele, index) => {
                    if (alleles[index].length === 1){
                        // Set short allele to empty string
                        alleles[index] = ""
                    }
                    else{
                        alleles[index] = allele.slice(region.start - variant.POS, allele.length)
                    }
                })
                // Set the start of the variant to the start of the region
                variant.POS = region.start
                relativePos = 0
            }
            else
            {
                throw(new Error(`Variant position ${variant.POS} out of region ${region.start}- ${region.end}`))
            }

        }
        // Apply SNP / Indel filter
        if (alleles.every(allele => allele.length === 1) && !filters.useSNPs){
            return;
        }else if (alleles.some(allele => allele.length > 1) && !filters.useIndels){
            return;
        }

        // Modify the allele for each individual
        const samples = variant.SAMPLES;
        //console.log(samples) 
        // Stores the number of bases to offset the individuals' sequences to mantain alignment (for insertions)
        let currentInsertionOffset = 0;

        // If no individuals are selected, do it for all samples
        if (allIndividuals)
            individuals = Object.keys(samples)
        //console.log(variant)
        individuals.forEach((indiv, index) => {
            
            if(allIndividuals){
                // Initialize sequence for individual if it does not exist
                if (!(sequencePrefix+indiv in sequences)){
                    sequences[sequencePrefix+indiv] = [...referenceSequence]
                }
            }
            // Check if individual is in variant samples
            if(!(indiv in samples))
                console.warn(`Individual ${indiv} not in variant`)
            else{
                // Check if sample passes filters
                if (filters.minDepth && samples[indiv].DP < filters.minDepth){
                    //console.log(`Sample ${indiv} depth ${samples[indiv].DP} is lower than ${filters.minDepth} in variant ${variant.POS}`)
                    return;
                }
                // Check if genotype array has only 1 genotype
                if (samples[indiv].GT.length !== 1){
                    throw(new Error(`Genotype ${samples[indiv].GT} of ${indiv} is not valid, it has more than 1 genotype`))
                }

                // Split genotype in alleles X/Y or X|Y => [X,Y]
                let divider = '/'
                if (samples[indiv].GT[0][1] === '|')
                    divider = '|'
                let genotype = samples[indiv].GT[0].split(divider)

                // Check if genotype is valid (only 2 alleles) since it is a diploid organism
                if (genotype.length !== 2){
                    throw(new Error(`Genotype ${samples[indiv].GT[0]} of ${indiv} is not valid, it has more than 2 alleles`))
                }

                // Check that genotype is not fully missing
                if( genotype[0]!== '.' && genotype[1]!== '.'){
                    const possibleAlleles = []
                    // For each genotype
                    for(let i = 0; i<2; i++){
                        // If data is not missing and is different from reference
                        if (genotype[i] !== '.' ){
                            const possibleAllele = alleles[parseInt(genotype[i])]    
                            // If it is a simple SNP or an insertion 
                            if ((possibleAllele.length === 1 && alleles[0].length === 1) || (genotype[i] !== '0' && possibleAllele.length > alleles[0].length)){
                                possibleAlleles.push(possibleAllele)
                            }
                            // Its a deletion, which only needs changes if it does not match the reference
                            else if( genotype[i] !== '0' && possibleAllele.length < alleles[0].length){
                                possibleAlleles.push(possibleAllele.concat('-'.repeat(alleles[0].length - possibleAllele.length)))
                            }
                            else
                            {
                                // console.log(possibleAllele, alleles[0], genotype[i])
                                //throw(new Error(`Unexpected conditions in VCF file`))
                            }
                                
                            
                        }
                    }
                    const indivVariantConsensus = []
                    // Build consensus sequence/allele for this variant and individual
                    // Iterate base by base and build the consensus for the individual in this variant
                    const maxLength = Math.max(possibleAlleles[0]? possibleAlleles[0].length: 0, possibleAlleles[1]? possibleAlleles[1].length:0)
                    for(let i=0; i< maxLength; i++){
                        let baseCandidates = ['', '']
                        if (possibleAlleles[0] && i< possibleAlleles[0].length)
                            baseCandidates[0] = possibleAlleles[0][i]
                        if (possibleAlleles[1] && i< possibleAlleles[1].length)
                            baseCandidates[1] = possibleAlleles[1][i]
                        
                        if (baseCandidates[0] === baseCandidates[1])
                            indivVariantConsensus.push(baseCandidates[0])
                        else{
                            // "-" takes preference over any other base
                            if("-" in baseCandidates)
                            {
                                indivVariantConsensus.push('-')
                            }
                            else{
                                // Remove - from the candidates
                                baseCandidates.sort()
                                const candidate = baseCandidates.join('')
                                if (candidate in alleleToIUPAC){
                                    indivVariantConsensus.push(alleleToIUPAC[candidate])
                                }
                                else if(candidate === ''){
                                    indivVariantConsensus.push('-')
                                }
                                else{
                                    indivVariantConsensus.push(candidate)
                                }
                            }
                                
                        }
                    }
                    // Check if there are any - in the consensus sequence
                    const dashIndex = indivVariantConsensus.indexOf('-')
                    // If there are, don't count them towards the offset (we only offset the additional bases that are not -)
                    const numberOfDashes = dashIndex === -1? 0: indivVariantConsensus.length - dashIndex

                    const offset = indivVariantConsensus.length - 1 - numberOfDashes
                    // Add offset to all sequences if needed
                    // If insertion is longer than the previous one, we have to space out the sequences to maintain alignment
                    if (offset > currentInsertionOffset){
                        // Add as many - as needed in the current relative position  to all the sequences
                        const offsetArr = Array(offset - currentInsertionOffset).fill('-')
                        individuals.forEach((i) => {
                            sequences[i].splice(relativePos + 1, 0, ...offsetArr)
                        })
                        sequences['reference'].splice(relativePos + 1, 0, ...offsetArr)

                        currentInsertionOffset = offset
                    }
                    // Replace individual sequence with indivVariantConsensus
                    sequences[sequencePrefix+indiv].splice(relativePos, indivVariantConsensus.length, ...indivVariantConsensus) 
                    //console.log(indiv, sequences[indiv])
                }
            }
        });
        totalOffset += currentInsertionOffset;
        offsets[relativePos+1] = totalOffset;
    });

    // Sanity check: check that all sequences have the same length
    const firstLength = Object.values(sequences)[0].length
    if (Object.values(sequences).every(({length}) => length !== firstLength)){
        throw new Error(`Sequences have different lengths`)
    }


    return [sequences, offsets];
}
function buildConsensus(sequences){
    // Build global consensus sequence
    sequences['consensus'] = [...sequences['reference']]
    const individuals = Object.keys(sequences).filter((key) => key !== 'consensus' && key !== 'reference')
    // Iterate base by base of every individual and build the consensus for the variant
    for(let i=0; i< sequences['consensus'].length; i++){
        const consensusAlleles = individuals.map((indiv) => sequences[indiv][i]);
        // Remove duplicates
        const consensusAllelesSet = new Set(consensusAlleles);

        // If there is a deletion, it has priority over the consensus
        if (consensusAllelesSet.has('-'))
            sequences['consensus'][i] = '-'
        else{
            // Translate IUPAC codes into multiple alleles
            consensusAllelesSet.forEach((code) => {
                if(code in IUPACToAllele)
                {
                    consensusAllelesSet.delete(code);
                    [...IUPACToAllele[code]].forEach((allele) => consensusAllelesSet.add(allele));
                }
                    
            });

            // Get consensus allele by getting the matching IUPAC code for the sample and reference alleles
            const consensusAllelesStr = Array.from(consensusAllelesSet).sort().join('')
            if(consensusAllelesStr.length === 1)
                sequences['consensus'][i] = consensusAllelesStr
            else if (consensusAllelesStr in alleleToIUPAC)
                sequences['consensus'][i] = alleleToIUPAC[consensusAllelesStr]
            else if (consensusAllelesStr !== '')
                throw(new Error(`Allele ${consensusAllelesStr} not recognized`) )
        }
        
    }
    return sequences;
}
async function readVariantInfo(vcfFile, tbiFile, region){
    const tbiIndexed = new TabixIndexedFile({ 
        filehandle: openLocation({
          uri: vcfFile, 
          locationType: 'UriLocation'}),
        tbiFilehandle: openLocation({
          uri: tbiFile, 
          locationType: 'UriLocation'}),
        })  
    const headerText = await tbiIndexed.getHeader()
    const tbiVCFParser = new VCF({ header: headerText })
    const sequence_names = await tbiIndexed.getReferenceSequenceNames()
    let chr = region.chr.toString()
    // If chromosome is not in the sequence names, alert
    if (!sequence_names.includes(chr)){
        console.warn(`Chromosome ${chr} (of the reference sequence) not found in submitted VCF file, assuming the VCF contains only one chromosome, so we use the first chromosome found`);
        chr = sequence_names[0];
    }
    const variants = []
    
    await tbiIndexed.getLines(chr.toString(), region.start-1, region.end, line =>
        variants.push(tbiVCFParser.parseLine(line)),
    )
    //console.log(variants)
    return variants
}
async function readReferenceSequence(fastaFile, faiFile, region){
    const t = new IndexedFasta({
        fasta: openLocation({
            uri: fastaFile, 
            locationType: 'UriLocation'}),
        fai: openLocation({
            uri: faiFile, 
            locationType: 'UriLocation'}),
        chunkSizeLimit:Number.MAX_VALUE,
        })  
    
  
    //console.log(await t.getSequenceNames())
  
    // TODO: Check sizes are within bounds of sequence
    
    // Ojo! Needs start-1 to be consistent with samtools faidx
    // Todo prepend 0 to chr when region 0 is only one digit
    return await t.getSequence(region.chr, parseInt(region.start)-1, parseInt(region.end))
}
export default generateSequences;